var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import mediumZoom from 'medium-zoom';
import { Block } from './block';
import { useNotionContext, NotionContextProvider } from './context';
import { CalendarModal } from './components/calendar-modal';
import ErrorBoundary from './components/ErrorBoundary';
import { useCollection } from './hooks/useCollection';
import { UseRetrieveBlocks } from './hooks/useRetrieveBlocks';
export var NotionRenderer = function (_a) {
    var components = _a.components, recordMap = _a.recordMap, mapPageUrl = _a.mapPageUrl, mapImageUrl = _a.mapImageUrl, searchNotion = _a.searchNotion, fullPage = _a.fullPage, rootPageId = _a.rootPageId, rootDomain = _a.rootDomain, darkMode = _a.darkMode, previewImages = _a.previewImages, forceCustomImages = _a.forceCustomImages, showCollectionViewDropdown = _a.showCollectionViewDropdown, showTableOfContents = _a.showTableOfContents, minTableOfContentsItems = _a.minTableOfContentsItems, showBreadcrumb = _a.showBreadcrumb, defaultPageIcon = _a.defaultPageIcon, defaultPageCover = _a.defaultPageCover, defaultPageCoverPosition = _a.defaultPageCoverPosition, _b = _a.fetchBlocks, fetchBlocks = _b === void 0 ? null : _b, _c = _a.fetchPage, fetchPage = _c === void 0 ? null : _c, _d = _a.retrieveImageBlocks, retrieveImageBlocks = _d === void 0 ? null : _d, _e = _a.queryCollection, queryCollection = _e === void 0 ? null : _e, _f = _a.weekStartsOn, weekStartsOn = _f === void 0 ? 6 : _f, _g = _a.hidePageProperty, hidePageProperty = _g === void 0 ? false : _g, fetchHashmap = _a.fetchHashmap, navbar = _a.navbar, rest = __rest(_a, ["components", "recordMap", "mapPageUrl", "mapImageUrl", "searchNotion", "fullPage", "rootPageId", "rootDomain", "darkMode", "previewImages", "forceCustomImages", "showCollectionViewDropdown", "showTableOfContents", "minTableOfContentsItems", "showBreadcrumb", "defaultPageIcon", "defaultPageCover", "defaultPageCoverPosition", "fetchBlocks", "fetchPage", "retrieveImageBlocks", "queryCollection", "weekStartsOn", "hidePageProperty", "fetchHashmap", "navbar"]);
    var zoom = typeof window !== 'undefined' &&
        mediumZoom({
            background: 'rgba(0, 0, 0, 0.8)',
            margin: getMediumZoomMargin()
        });
    var _h = useState(false), calendarModal = _h[0], setCalendarModal = _h[1];
    var _j = useState({
        date: new Date(),
        blocks: []
    }), calendarControls = _j[0], setCalendarControls = _j[1];
    var updateCalendarModal = function (controls, show) {
        setCalendarControls(controls);
        setCalendarModal(show);
    };
    return (React.createElement(NotionContextProvider, { components: components, recordMap: recordMap, mapPageUrl: mapPageUrl, mapImageUrl: mapImageUrl, searchNotion: searchNotion, fullPage: fullPage, rootPageId: rootPageId, rootDomain: rootDomain, darkMode: darkMode, previewImages: previewImages, forceCustomImages: forceCustomImages, showCollectionViewDropdown: showCollectionViewDropdown, showBreadcrumb: showBreadcrumb, showTableOfContents: showTableOfContents, minTableOfContentsItems: minTableOfContentsItems, defaultPageIcon: defaultPageIcon, defaultPageCover: defaultPageCover, defaultPageCoverPosition: defaultPageCoverPosition, zoom: zoom, fetchBlocks: fetchBlocks, fetchPage: fetchPage, retrieveImageBlocks: retrieveImageBlocks, queryCollection: queryCollection, weekStartsOn: weekStartsOn, hidePageProperty: hidePageProperty, calendarMobileModalControls: calendarControls, updateCalendarControls: updateCalendarModal, fetchHashmap: fetchHashmap, navbar: navbar },
        React.createElement(CalendarModal, { show: calendarModal }),
        React.createElement(NotionBlockRenderer, __assign({}, rest))));
};
export var NotionBlockRenderer = function (_a) {
    var _b, _c;
    var _d = _a.level, level = _d === void 0 ? 0 : _d, blockId = _a.blockId, props = __rest(_a, ["level", "blockId"]);
    var recordMap = useNotionContext().recordMap;
    var _e = useCollection(), retrieveCollectionId = _e.retrieveCollectionId, retrievePage = _e.retrievePage;
    var retrieveMissingBlocks = UseRetrieveBlocks().retrieveMissingBlocks;
    var firstId = Object.keys(recordMap.block)[0];
    var id = blockId || firstId;
    var block = (_b = recordMap.block[id]) === null || _b === void 0 ? void 0 : _b.value;
    if (!block) {
        if (process.env.NODE_ENV !== 'production')
            console.warn('missing block', blockId);
        retrieveMissingBlocks([{ table: 'block', id: id }]);
        return null;
    }
    var keys = Object.keys(recordMap.block).filter(function (id) { return id != firstId; });
    if (level == 0 && keys.length > 0) {
        var collectionPages = keys
            .map(function (key) { return recordMap.block[key]; })
            .filter(function (block) { var _a; return ((_a = block === null || block === void 0 ? void 0 : block.value) === null || _a === void 0 ? void 0 : _a.type) == 'collection_view'; })
            .filter(function (block) {
            return !retrieveCollectionId(block);
        })
            .map(function (b) { return b.value; });
        retrievePage(collectionPages.map(function (b) { return ({ id: b.id, spaceId: b.space_id }); }));
        // fetch all the alias page and try to fetch the missing aliases
        var missingAliasIds = Object.entries(recordMap.block)
            .filter(function (entry) { var _a, _b; return ((_b = (_a = entry[1]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.type) == 'alias'; })
            .map(function (entry) { return entry[1].value.format; })
            .filter(function (f) { var _a; return !recordMap.block[(_a = f === null || f === void 0 ? void 0 : f.alias_pointer) === null || _a === void 0 ? void 0 : _a.id]; })
            .filter(function (f) { var _a; return (_a = f === null || f === void 0 ? void 0 : f.alias_pointer) === null || _a === void 0 ? void 0 : _a.id; })
            .map(function (f) { var _a; return ({ table: 'block', id: (_a = f === null || f === void 0 ? void 0 : f.alias_pointer) === null || _a === void 0 ? void 0 : _a.id }); });
        if (missingAliasIds.length > 0)
            retrieveMissingBlocks(missingAliasIds);
    }
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Block, __assign({ key: id, level: level, block: block }, props), (_c = block === null || block === void 0 ? void 0 : block.content) === null || _c === void 0 ? void 0 : _c.map(function (contentBlockId) {
            var _a;
            var cBlock = recordMap.block[contentBlockId];
            if (block.type == 'transclusion_container' &&
                ((_a = cBlock === null || cBlock === void 0 ? void 0 : cBlock.value) === null || _a === void 0 ? void 0 : _a.type) == 'transclusion_reference')
                return null;
            return (React.createElement(NotionBlockRenderer, __assign({ blockId: contentBlockId, key: contentBlockId, level: level + 1 }, props)));
        }))));
};
function getMediumZoomMargin() {
    var width = window.innerWidth;
    if (width < 500) {
        return 8;
    }
    else if (width < 800) {
        return 20;
    }
    else if (width < 1280) {
        return 30;
    }
    else if (width < 1600) {
        return 40;
    }
    else if (width < 1920) {
        return 48;
    }
    else {
        return 72;
    }
}
//# sourceMappingURL=renderer.js.map